import { render, staticRenderFns } from "./StaticTextModal.vue?vue&type=template&id=79524b2e&"
import script from "./StaticTextModal.vue?vue&type=script&lang=js&"
export * from "./StaticTextModal.vue?vue&type=script&lang=js&"
import style0 from "./StaticTextModal.vue?vue&type=style&index=0&id=79524b2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports